import axios, {AxiosInstance, AxiosRequestConfig} from "axios";
import {formatMessage} from "@/locale"

/**
 * Axios配置
 */
const config: AxiosRequestConfig = {
    timeout: process.env.VUE_APP_HTTP_TIMEOUT,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
};

/**
 * http请求实例
 */
const http:AxiosInstance = axios.create(config);

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    // 请求头带上token
    //config.headers["token"] = localStorage.getItem("token");
    return config;
  },
  error => {
    return {
        rspInfo: {
            code:"100000",
            msg: formatMessage({id:"message.common.networkError"})
        }
    };
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  response => {
    const status = response.status;
    const rspData = response.data;

    //console.log("状态码：" + status + "，返回内容：" + JSON.stringify(rspData));
    
    return rspData;
  },
  error => {
    const status = error.response.status;
    const rspData = error.response.data;
    
    //console.log("状态码：" + status + "，返回内容：" + JSON.stringify(rspData));
    return {
      rspInfo: {
        code: "200007",
        msg: formatMessage({id:"message.common.networkError"})
      }
    };
  }
);

export default http;
